import ActualProfitAndLoss from "./index.js";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
export default function ActualPrAndLo() {
  return (
    <DashboardLayout>
      <ActualProfitAndLoss />
    </DashboardLayout>
  );
}
